export enum EPackType {
  Box = 'Hộp'
}
